import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ben-loading',
  template: '<mat-spinner [diameter]="diameter" [class]="class"></mat-spinner>',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  @Input() diameter: number = 80;
  @Input() class: string = "";
  constructor() { }

  ngOnInit(): void {
  }

}